<template>
  <div id="content" :class="$route.name">
    <div class="overlay show" v-if="isOverlayShow">
      <div id="loading-spinner">
        <div class="spin-icon"></div>
      </div>
    </div>
    <vue-progress-bar></vue-progress-bar>
    <notifications group="foo" position="bottom right" />
    <div class="container-fluid">
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </div>
    <mainFooter v-if="checkRoute()"></mainFooter>
  </div>
</template>

<script>
const mainFooter = () => import("../shared/mainFooter.vue");
import { eventBus } from "@/main";

export default {
  data() {
    return {
      databaseURL: process.env.ROOT_API,
      isHeaderHidden: false,
      isOverlayShow: false
    };
  },
  components: {
    mainFooter,
  },
  mounted() {
    let vm = this;
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
    eventBus.$on("showOverlay", isShow => {
      vm.isOverlayShow = isShow;
    });
  },
  methods: {
    checkRoute() {
      if (this.$route.name == "Home" || this.$route.name == "courses" || this.$route.name == "schoolBusiness" || this.$route.name == "examRegistration" || this.$route.name == "Pricing") {
        return true
      } else {
        return false
      }
    }
  }
};
</script>


<style scoped>
.overlay {

  z-index: 9999;
  margin: 0 auto;
  display: inherit;

}

.overlay {
  z-index: 99999;
}

#loading-spinner {
  display: inline;
  position: relative;
  z-index: 999999;
}

#loading-spinner .spin-icon {
  margin: auto;
  width: 80px;
  height: 80px;
  margin-top: 24%;
  border: solid 3px transparent;
  border-top-color: #001f5b;
  border-left-color: #49c1df;
  border-radius: 80px;

  -webkit-animation: loading-spinner 500ms linear infinite;
  -moz-animation: loading-spinner 500ms linear infinite;
  -ms-animation: loading-spinner 500ms linear infinite;
  -o-animation: loading-spinner 500ms linear infinite;
  animation: loading-spinner 500ms linear infinite;
}

@-webkit-keyframes loading-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes loading-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes loading-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes loading-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/student.vue